var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: { "offset-y": "", "open-on-hover": "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g({ attrs: { icon: "" } }, on),
                [_c("v-icon", [_vm._v("mdi-sort")])],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "v-list",
        { attrs: { dense: "" } },
        _vm._l(_vm.sorts, function(s) {
          return _c(
            "v-list-item",
            { key: s.name },
            [
              _c("v-list-item-title", [_vm._v(_vm._s(s.name))]),
              _vm._v(" "),
              _c("v-spacer", { staticClass: "ml-3" }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "pa-0 ma-0",
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.sortBy(s.field, "asc")
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { color: "primary" } }, [
                    _vm._v("mdi-sort-ascending")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "pa-0 ma-0",
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.sortBy(s.field, "desc")
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { color: "primary" } }, [
                    _vm._v("mdi-sort-descending")
                  ])
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }